import angular from 'angular';
import uiRouter from 'angular-ui-router';
import officesComponent from './offices.component';
import Office from './office/office';

let officesModule = angular.module('offices', [uiRouter, Office])
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider
      .state('offices', {
        url: '/offices',
        component: 'offices',
        resolve: {
          $title: () => 'Sedi'
        }
      });
  })
  .component('offices', officesComponent)
  .name;

export default officesModule;



// WEBPACK FOOTER //
// ./client/app/components/offices/offices.js